import React from 'react';

import { useUserProfileQuery } from '@services/user/useUserProfileQuery';

import { findInstallationPointsByAssetCodes } from '../../helpers/findInstallationPointsByAssetCodes';
import FirstRow from './FirstRow';
import FourthRow from './FourthRow';
import SecondRow from './SecondRow';
import ThirdRow from './ThirdRow';
import style from './style.module.scss';

interface IProps {
  locationsAssetsData: any[]; //TODO:remove any
}

const SensorsEquipmentsArea: React.FC<IProps> = ({ locationsAssetsData }) => {
  const { data: profileData } = useUserProfileQuery();

  const user = profileData?.user;

  const installationPoints = findInstallationPointsByAssetCodes(locationsAssetsData);

  const userMetric = user?.use_metric === 1 ? '°F' : '°C';

  return (
    <div className={style.sensorsEquipmentsAreaContainer}>
      <FirstRow userMetric={userMetric} />
      <SecondRow userMetric={userMetric} />
      <ThirdRow installationPoints={installationPoints} userMetric={userMetric} />
      <FourthRow userMetric={userMetric} />
    </div>
  );
};

export default SensorsEquipmentsArea;
